// extracted by mini-css-extract-plugin
export default {"wrapper":"modal-wrapper_wrapper__7RVmB","container":"modal-wrapper_container__U2IGI"};